'use client';

import ProgressAnime from '@/components/ui/ProgressAnime/ProgressAnime';
import utilsStyles from '@/styles/modules/utils.module.scss';
import { useEffect, useRef, useState } from 'react';
import { getBizCreatorList } from '../../api/getBizCreatorList';
import { CreatorListItem } from '../../types';
import BizCreatorList from '../BizCreatorList/BizCreatorList';
import ECommerceSearchNotFound from '../ECommerceSearchNotFound/ECommerceSearchNotFound';

function BizCreatorInfiniteList({
  creators,
  pageLimit,
  query,
  requestTime,
  bizTeamId,
}: {
  creators: Array<CreatorListItem>;
  pageLimit: number;
  query?: string;
  requestTime: string;
  bizTeamId?: number;
}) {
  const [hasNoMore, setHasNoMore] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [currentCreatorsList, setCurrentCreatorsList] = useState(creators);
  const targetRef = useRef<HTMLDivElement>(null);

  function handleScroll() {
    const scrollingBottom = targetRef.current?.getBoundingClientRect().bottom;
    if (!scrollingBottom) return;
    if (canFetch(scrollingBottom)) {
      fetchMore();
    }
  }

  const fetchMore = async () => {
    setIsLoading(true);
    window.removeEventListener('scroll', handleScroll); //一回削除
    const lastId = currentCreatorsList.slice(-1)[0].id;

    const { result: moreCreatorList } = await getBizCreatorList({
      oemServiceId: Number(process.env.NEXT_PUBLIC_SERVICE_ID),
      requestTime: requestTime,
      paging: 'next',
      limit: pageLimit,
      bizCreatorName: query || undefined,
      pagingBizCreatorId: lastId,
      bizTeamId: bizTeamId ?? undefined,
    });
    if (moreCreatorList.length === 0) {
      setHasNoMore(true);
      setIsLoading(false);
      return;
    }
    setCurrentCreatorsList([...currentCreatorsList, ...moreCreatorList]);
    setIsLoading(false);
    window.addEventListener('scroll', handleScroll); //　終わったら追加
  };

  const canFetch = (scrollingBottom?: number) => {
    if (!scrollingBottom) return false;
    return scrollingBottom < window.innerHeight + 60 && !hasNoMore && !isLoading && creators.length > 0;
  };

  useEffect(() => {
    // スクロール処理
    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [currentCreatorsList]);

  return (
    <>
      {currentCreatorsList.length > 0 ? (
        <div ref={targetRef}>
          <BizCreatorList creators={currentCreatorsList}></BizCreatorList>
          {isLoading && <ProgressAnime></ProgressAnime>}
        </div>
      ) : (
        <div className={utilsStyles.mtLarge}>
          <ECommerceSearchNotFound></ECommerceSearchNotFound>
        </div>
      )}
    </>
  );
}

export default BizCreatorInfiniteList;
